import Input from '@mui/material/Input';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { PATH_NAME } from '../../configs/pathName';
import {
  ICommentForm,
  ICommentSideModal,
} from '../../interfaces/components/comment.interface';
import { QuickLoginModalHOC } from '../modal/LoginModal2HOC';

const CommentForm: React.FC<ICommentForm & ICommentSideModal> = ({
  placeholder,
  parentId,
  className,
  oldContent = '',
  commentId,
  handleCancel: _handleCancel,
  toast,
  autoFocus,
  handleAddGlobal,
  handleUpdateGlobal,
  commentSectionId,
}) => {
  const [commentContent, setCommentContent] = useState<string>(oldContent);
  const handleCancel = () => {
    setCommentContent('');
    _handleCancel && _handleCancel();
  };
  const router = useRouter();

  const handleSubmitComment = async () => {
    try {
      if (oldContent && commentId) {
        await handleUpdateGlobal(commentId, commentContent);
        toast(`Đã sửa ${parentId ? 'phản hồi' : 'bình luận'}!`, 'success');
      } else {
        await handleAddGlobal(commentContent, parentId);
        toast(`Đã đăng ${parentId ? 'phản hồi' : 'bình luận'}!`, 'success');
      }
      handleCancel();
    } catch (error) {
      toast(
        `Thất bại khi đăng ${
          parentId ? 'phản hồi' : 'bình luận'
        }. Kiểm tra kết nối của bạn và thử lại nhé.`,
        'error'
      );
    }
  };

  return (
    <div className={`w-full ${className}`}>
      <Input
        multiline
        className="!rounded-lg !border-none !bg-[#F1F1F1] !px-[16px] !py-[13px] !text-base !font-semibold placeholder:!text-base placeholder:!font-medium placeholder:!text-[#707070] focus:!outline-none"
        placeholder={placeholder}
        value={commentContent}
        onChange={(e) => setCommentContent(e.target.value)}
        fullWidth
        disableUnderline
        autoFocus={autoFocus}
      />

      <div className={`mt-2 flex items-stretch justify-end gap-2`}>
        <button
          disabled={!commentContent}
          className={`w-auto rounded-[6px] px-4 py-[10px] text-center text-sm transition-all ease-linear ${
            !commentContent ? 'bg-gray-300 text-white' : 'text-primary '
          }`}
          onClick={() => handleCancel()}
        >
          Hủy
        </button>
        <QuickLoginModalHOC
          classname="cursor-pointer"
          handleClickWhenDisabledQuickLogin={handleSubmitComment}
          // this only use for comment in post
          loginSuccessCb={() => {
            router.push(
              commentSectionId
                ? {
                    pathname: PATH_NAME.HOME_FEED_POST_DETAIL,
                    query: {
                      pid: commentSectionId,
                    },
                  }
                : PATH_NAME.LIBRARY
            );
          }}
        >
          <button
            disabled={!commentContent}
            type="submit"
            className={`w-auto rounded-[6px] px-4 py-[10px] text-center text-sm text-white transition-all ease-linear ${
              !commentContent
                ? 'bg-gray-300'
                : 'bg-primary_lighter hover:bg-primary'
            }`}
          >
            {oldContent && commentId
              ? 'Lưu'
              : parentId
              ? 'Phản hồi'
              : 'Bình luận'}
          </button>
        </QuickLoginModalHOC>
      </div>
    </div>
  );
};

export default CommentForm;
